module.exports = __webpack_public_path__ + "static/media/temtrol_logo.146534ff.svg";